import {Input, Card, Avatar, Button, Badge, Text} from "@fluentui/react-components";

import {DismissRegular,ChevronDownRegular,SearchRegular,AlertFilled} from "@fluentui/react-icons";

import {useState} from "react";
import Organization from "../domain/Organization";
import ViewInfo from "../domain/ViewInfo";
import "./TopBar.css";
interface ITopBarProps {
    organizations?: Organization[];
    selected?: Organization;
    onClickNotificationIcon: () => void;
    onClickSwitchOrganization: () => void;
    onSearchStateChange: (isSearchOpen: boolean) => void;
    onSearchSubmit: (searchText: string) => void;
    notificationViewInfo: ViewInfo;
    isSearchDisabled: boolean;
}

export default function TopBar (props: ITopBarProps) {
    const [isSearchOpen, setIsSearchOpen] = useState(false);

    function handleSearchClick  (){
        const _isSearchOpen: boolean = !isSearchOpen;
        if (props.onSearchStateChange) {
            props.onSearchStateChange(_isSearchOpen);
        }
        setIsSearchOpen(_isSearchOpen);
    }

    function notificationCount(): number {
        if (!props.notificationViewInfo) {
            return 0;
        }

        const newNotifications = props.notificationViewInfo.itemsToDisplay.filter((curItem) => {
            return curItem.isNewNotification && !curItem.isDismissed && !curItem.isClicked && !curItem.hasNotificationImpression;
        });

        const newNotificationsInPool = props.notificationViewInfo.itemsPool.filter((curItem) => {
            return curItem.isNewNotification && !curItem.isDismissed && !curItem.isClicked && !curItem.hasNotificationImpression;
        });

        return newNotifications.length + newNotificationsInPool.length;
    }

    function handleOnKeyDown  (e: any)  {
        if (e.keyCode === 13 && props.onSearchSubmit) {
            props.onSearchSubmit(e.target.value.trim());
        }
    }

    function render() {
        if (props.selected) {
            // <Input inverted icon={<SearchIcon />} placeholder="Search..." fluid styles={{maxWidth: "270px"}} iconPosition="start" />
            if (isSearchOpen) {
                return (
                    <div className="top-bar smt-flex smt-flex__ai-center smt-flex__gap-1">
                        <Button size={"medium"} shape={"circular"} onClick={handleSearchClick} icon={<DismissRegular/>}
                                disabled={props.isSearchDisabled}/>
                        <Input appearance="underline" placeholder="Search..." autoFocus onKeyDown={handleOnKeyDown} style={{width: "100%"}}
                               disabled={props.isSearchDisabled}/>
                    </div>
                );
            }


            return (
                <div className="top-bar smt-flex smt-flex__ai-center smt-flex__gap-1">
                    <Card onClick={props.onClickSwitchOrganization} className="org-selected">
                            <div className="smt-flex smt-flex__ai-center smt-flex__gap-1">
                                <div>
                                    <Avatar size={48} image={{src: props.selected.organizationIcon}} style={{ cursor: "pointer" }}  />
                                </div>
                                <div className="org-name" title={props.selected.organizationName}>
                                    <Text weight="semibold" size={500} style={{ cursor: "pointer" }} >{props.selected.organizationName}</Text>
                                </div>
                                <div className="smt-flex__push">
                                    <ChevronDownRegular fontSize={28} />
                                </div>
                            </div>
                    </Card>
                    <div className="smt-flex__push">
                        <Button shape={"circular"} size={"medium"} onClick={handleSearchClick} icon={<SearchRegular />} />
                    </div>
                    <div className="notification-btn-w">
                        <Button appearance={notificationCount() > 0 ? 'primary' : 'outline'}  shape={"circular"} size={"medium"} onClick={props.onClickNotificationIcon} icon={<AlertFilled />} />
                        {(notificationCount() > 0) && (<Badge onClick={props.onClickNotificationIcon} className="notification-status" title="New notifications available" size={"tiny"} shape={"circular"} color={"danger"} />)}
                    </div>
                </div>
            );
        }
        return (<div/>);


    }

    return render();
}
